// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5099c7f3","286":"701c8225","302":"24b3f0d0","421":"006ed967","446":"ab0aeeaf","453":"ca7732f1","470":"fa915555","716":"06caacc0","739":"2b50465b","759":"daea6620","829":"c6c66b2c","901":"15fec738"}[chunkId] + ".chunk.js";
};